import type { LayoutSection, LayoutSpec } from '../../../types/LayoutConfig';
import { CUSTOMER_ACTIVITY_LAYOUT_SPEC } from './Dealer/CustomerActivityLayoutSpec';
import { CUSTOMER_RISK_LAYOUT_SPEC } from './Dealer/CustomerRiskLayoutSpec';
import { EXECUTION_AND_PRICING_LAYOUT_SPEC } from './Dealer/ExecutionAndPricingLayoutSpec';
import { DEFAULT_INTEL_OVERVIEW_LAYOUT_SPEC } from './Intel/DefaultIntelOverviewLayoutSpec';
import { INTEL_FUNDING_RATES_LAYOUT_SPEC } from './Intel/IntelFundingRatesLayoutSpec';
import { INTEL_LEADERBOARD_LAYOUT_SPEC } from './Intel/IntelLeaderboardLayoutSpec';
import { CUSTOMER_GRID_MONITORING_LAYOUT_SPEC } from './Monitoring/CustomerGridMonitoringLayoutSpec';
import { DEFAULT_MONITORING_LAYOUT_SPEC } from './Monitoring/DefaultMonitoringLayoutSpec';
import { OMS_GRID_MONITORING_LAYOUT_SPEC } from './Monitoring/OmsGridMonitoringLayoutSpec';
import { ORDERS_TRADES_MONITORING_LAYOUT_SPEC } from './Monitoring/OrdersTradesMonitoringLayoutSpec';
import { THREE_COLUMN_MONITORING_LAYOUT_SPEC } from './Monitoring/ThreeColumnMonitoringLayoutSpec';
import { CARE_ORDERS_LAYOUT_SPEC } from './Trading/CareOrdersLayoutSpec';
import { CHART_VIEWS_LAYOUT_SPEC } from './Trading/ChartViewsLayoutSpec';
import { DEFAULT_TRADING_LAYOUT_SPEC } from './Trading/DefaultTradingLayoutSpec';
import { MANUAL_RFQS_LAYOUT_SPEC } from './Trading/ManualRFQsLayoutSpec';
import { OPTIONS_LAYOUT_SPEC } from './Trading/OptionsLayoutSpec';
import { ORDER_BOOKS_LAYOUT_SPEC } from './Trading/OrderBooksLayoutSpec';
import {
  CARE_ORDERS_LAYOUT_TEMPLATE_ID,
  CHART_VIEWS_LAYOUT_ID,
  DEALER_CUSTOMER_RISK_LAYOUT_ID,
  DEALER_EXECUTION_AND_PRICING_LAYOUT_ID,
  DEFAULT_LAYOUT_ID,
  INTEL_FUNDING_RATES_LAYOUT_ID,
  INTEL_LEADERBOARD_LAYOUT_ID,
  INTEL_OVERVIEW_LAYOUT_ID,
  MANUAL_RFQS_LAYOUT_TEMPLATE_ID,
  OPTIONS_LAYOUT_ID,
  OPTIONS_LAYOUT_TEMPLATE_ID,
  ORDER_BOOKS_LAYOUT_ID,
} from './tokens';

const DEFAULT_TRADING_LAYOUTS: Record<string, LayoutSpec> = {
  [DEFAULT_LAYOUT_ID]: DEFAULT_TRADING_LAYOUT_SPEC,
  [ORDER_BOOKS_LAYOUT_ID]: ORDER_BOOKS_LAYOUT_SPEC,
  [CHART_VIEWS_LAYOUT_ID]: CHART_VIEWS_LAYOUT_SPEC,
  // Registered under both layout id and template id so that URL resolution and per-space
  // layout reset both work. Visibility is gated in Trading/conditionalLayoutSpecs.ts.
  [OPTIONS_LAYOUT_ID]: OPTIONS_LAYOUT_SPEC,
  [OPTIONS_LAYOUT_TEMPLATE_ID]: OPTIONS_LAYOUT_SPEC,
  [CARE_ORDERS_LAYOUT_TEMPLATE_ID]: CARE_ORDERS_LAYOUT_SPEC,
  [MANUAL_RFQS_LAYOUT_TEMPLATE_ID]: MANUAL_RFQS_LAYOUT_SPEC,
};

const DEFAULT_MONITORING_LAYOUTS: Record<string, LayoutSpec> = {
  default: DEFAULT_MONITORING_LAYOUT_SPEC,
  ordersTrades: ORDERS_TRADES_MONITORING_LAYOUT_SPEC,
  omsGrid: OMS_GRID_MONITORING_LAYOUT_SPEC,
  customerGrid: CUSTOMER_GRID_MONITORING_LAYOUT_SPEC,
  threeColumn: THREE_COLUMN_MONITORING_LAYOUT_SPEC,
};

const DEFAULT_INTEL_LAYOUTS: Record<string, LayoutSpec> = {
  [INTEL_OVERVIEW_LAYOUT_ID]: DEFAULT_INTEL_OVERVIEW_LAYOUT_SPEC,
  [INTEL_LEADERBOARD_LAYOUT_ID]: INTEL_LEADERBOARD_LAYOUT_SPEC,
  [INTEL_FUNDING_RATES_LAYOUT_ID]: INTEL_FUNDING_RATES_LAYOUT_SPEC,
};

const DEFAULT_DEALER_LAYOUTS: Record<string, LayoutSpec> = {
  [DEFAULT_LAYOUT_ID]: CUSTOMER_ACTIVITY_LAYOUT_SPEC,
  [DEALER_CUSTOMER_RISK_LAYOUT_ID]: CUSTOMER_RISK_LAYOUT_SPEC,
  [DEALER_EXECUTION_AND_PRICING_LAYOUT_ID]: EXECUTION_AND_PRICING_LAYOUT_SPEC,
};

export const DEFAULT_LAYOUTS: Record<LayoutSection, Record<string, LayoutSpec>> = {
  trading: DEFAULT_TRADING_LAYOUTS,
  monitoring: DEFAULT_MONITORING_LAYOUTS,
  intel: DEFAULT_INTEL_LAYOUTS,
  dealer: DEFAULT_DEALER_LAYOUTS,
};
